<form name="frmRetaggingOfCalls"  style="margin-top:-1.5%;">
    <div class="container panel panel-default col-md-12"
        style="padding-left:0%;padding-right:0%;border-color:black;min-height:80vh;">
        <div class="panel panel-heading"
            style=" background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.2%; color: white;">
            Retagging Of Calls</div>
        <div class="panel-body">
            <div class="activity-box" *ngIf="dataLoader"><div class="loading-spiner"><img src="assets/img/loadingVer.gif" class="load"/></div></div>
            <div class="form-group row" style="margin-top:-2%;">
                <div class="col-sm-14">
                    <div class="form-group row">
                        <div class="col-sm-3 formdivcaptions" style="width:auto">
                            <label style="color:black;font-weight:bold;margin-right:30px;">Device Type</label>
                            <label *ngFor="let DeviceType of DeviceTypeList">
                                <input type="radio" name="radioDeviceType" value="{{DeviceType.name}}"
                                    (change)="DeviceTypeEvent($event.target.value)" /><label>&nbsp;{{DeviceType.name}}&nbsp;
                                </label>
                            </label>
                        </div>
                    </div>

                    <div class="form-group row" id="divSearch" [ngStyle]="{'display':divSearch}">
                        <div class="col-sm-14">
                            <div class="col-sm-5">
                                <label>Period</label>
                                <input type="text" matInput name="srchFromDate" id="srchFromDate"
                                    placeholder="Select Date" [(ngModel)]="FromDate" style="height:33px;width:150px;"
                                    [matDatepicker]="frmDate" class="datepicker form-control"
                                    (focus)="showFromDatePicker()" />
                                <mat-datepicker #frmDate></mat-datepicker>
                                <div class="col-sm-3" style="margin-top: -7%; margin-left: 32.5%;">
                                    <label>To:</label>
                                </div>
                                <div class="col-sm-3" style="margin-top: -7%; margin-left: 38%;">
                                    <input type="text" matInput name="srchToDate" id="srchToDate"
                                        placeholder="Select Date" [(ngModel)]="ToDate"
                                        style="height: 33px; width: 150px;" [matDatepicker]="toDate"
                                        class="datepicker form-control" (focus)="showtoDatePicker()" />
                                    <mat-datepicker #toDate></mat-datepicker>
                                </div>
                            </div>
                            <div class="col-sm-3" style="margin-left:-10%">
                                <label for="dlstCountry">Country</label>
                                <select class="form-control col-sm-4" id="dlstCountry" name="dlstCountry"
                                    [(ngModel)]="dlstCountries" style="height: 33px;">
                                    <option value="" selected="selected">&lt;--Select--&gt;</option>
                                    <option *ngFor="let C of Countries">{{C.Country}}</option>
                                </select>
                            </div>
                            <div class="col-sm-3">
                                <label for="dlstCallStatuses">Call Status</label>
                                <select class="form-control col-sm-4" id="dlstCallStatuses" name="dlstCallStatuses"
                                    [(ngModel)]="dlstCallStatus">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let M of MarkList" value="{{M.Value}}">{{M.Value}}</option>
                                </select>
                            </div>
                            <div class="col-sm-2">
                                <label for="txtEntId">Enterprise ID</label>
                                <input type="text" class="form-control" id="txtEntId" name="txtEntId"
                                    [(ngModel)]="txtenterpriseID" />
                            </div>
                        </div>

                        <div class="col-sm-12 formdivcaptions" style="margin-top:2%;">
                            <div align="center" id="divSubmit" [ngStyle]="{'display':divSubmit}">
                                <button type="submit" id="btnSearch" class="btn btn-default btn-group-sm Button1"
                                    (click)="ShowData()"><span class="fa fa-search-plus" aria-hidden="true"></span>
                                    Search</button> &nbsp;
                                <button type="submit" id="searchClear" class="btn btn-default btn-group-sm Button1"
                                    (click)="Clear()"><span class="fa fa-close" aria-hidden="true"></span>
                                    Clear</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row table-responsive" id="divDetails" [ngStyle]="{'display':divDetails}">
                <div style="margin-right:20px">
                    <table id="CallrateDetails" class="table table-bordered" border="1"
                        style="width: 80%; font-size: 13px; overflow: scroll;">
                        <tr style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                            <th style="display:none">S.No</th>
                            <th><label style="width:30px; text-align :center;"><input type="checkbox"
                                        (click)="checkAll($event.target.checked)" id="selectedAll" [checked]="select_all_data" title="selectedAll"/></label> </th>
                            <th style="text-align: center; min-width: 100px;">Enterprise ID</th>
                            <th style="text-align: center;min-width:90px">Date</th>
                            <th style="text-align: center;">Time</th>
                            <th style="text-align: center; min-width: 100px;">Called Number</th>
                            <th style="text-align: center;">Extension</th>
                            <th style="text-align: center;">Duration</th>
                            <th style="text-align: center;">Cost</th>
                            <th style="text-align: center; min-width: 100px;">Call Status</th>
                            <th style="text-align: center; min-width: 150px;">Approval Status</th>
                            <th style="text-align: center; min-width: 100px;">WBS Element</th>
                            <th style="text-align: center; min-width: 150px;">Reviewer</th>
                            <th style="text-align: center; min-width: 100px;">Date Approved</th>
                            <th style="text-align: center; min-width: 90px;">Date Posted</th>
                            <th style="text-align: center; min-width: 90px; ">Auto Processed</th>
                        </tr>
                        <tbody *ngFor="let data of successfulData.retagging">
                            <div *ngIf="getTemplate(data) == 'display'; then displayBlock"></div>
                            <ng-template #displayBlock>
                                <tr>
                                    <td style="display:none">{{data.Id}}</td>
                                    <td>
                                        <label style="width:25px"><input type="checkbox" id="contact{{data.Id}}"
                                                style="margin-left:5px;" (change)="CallStatusChange(data)" [checked]="data.checked" title="contact{{data.Id}}"/></label>
                                    </td>
                                    <td>{{data.eId}}</td>
                                    <td>{{data.date}}</td>
                                    <td>{{data.time}}</td>
                                    <td>{{data.originalCalledPartyNumber}}</td>
                                    <td>{{data.callingPartyNumber}}</td>
                                    <td>{{data.cduration}}</td>
                                    <td>{{data.callCost}}</td>
                                    <td>{{data.callStatus}}</td>
                                    <td>{{data.approvalStatus}}</td>
                                    <td>{{data.wbs}}</td>
                                    <td>{{data.approverEid}}</td>
                                    <td>{{data.approvalDate | date : 'yyyy-MM-dd hh:mm:ss a'}}</td>
                                    <td>{{data.datePosted | date : 'yyyy-MM-dd hh:mm:ss a'}}</td>
                                    <td>{{data.isAutoProcessed}}</td>
                                </tr>
                            </ng-template>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="15" style="text-align: center;">
                                    <!-- pager -->
                                    <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                            <a><i (click)="setPage(1)" class="icon-fast-backward"></i>
                                            </a>
                                        </li>
                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                            <a><i (click)="setPage(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                        </li>
                                        <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                            <a (click)="setPage(page)">{{page}}</a>
                                        </li>
                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                            <a (click)="setPage(pager.startPage + 5)">...</a>
                                        </li>
                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                            <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                        </li>
                                        
                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                            <a><i (click)="setPage(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                        </li>
                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                            <a><i (click)="setPage(pager.totalPages)" class="icon-fast-forward"></i></a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            <!-- Model -->
            <!-- <ng-template title="Retagging Details" #modalcontent let-modal id="divMark"> -->
            <div class="overlay" [ngStyle]="{'display':displayPopUp}">
                <div class="modal" tabindex="-1" role="dialog">
                    <div class="modal-header">
                        <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
                                aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Retagging Details</h4>
                    </div>
                    <div class="modal-body" style="height: 160vh;">
                        <div class="form-group row">
                            <div class="col-sm-3 col-md-offset-1" style="padding-top: 1%; margin-top: -10px;">
                                <span class="tooltip" style="position: relative;">
                                    <img alt="" src="assets/img/info10.png" class="img-circle"
                                        style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 79%;">
                                    <span class="tooltiptext" style="margin-bottom: -16px;">The purpose of call made by
                                        caller.</span>
                                </span>
                                <label for="Mark As">Mark As:</label>
                            </div>
                            <div class="col-sm-4">
                                <select class="form-control" id="MarkAs" name="MarkAs"
                                    [(ngModel)]="successfulData.selected.callStatus" (change)="MarkAction(successfulData.selected.callStatus)">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let M of MarkList" value="{{M.Value}}">{{M.Value}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group row" id="divWBSElement" [hidden]="!showWBSElement">
                            <div class="col-sm-3 col-md-offset-1" style="margin-top: -15px;">
                                <span class="tooltip" style=" position: relative;">
                                    <img alt="" src="assets/img/info10.png" class="img-circle"
                                        style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 79%;">
                                    <span class="tooltiptext" style="margin-bottom: -16px;">Cost collector to charge the
                                        call.</span>
                                </span>
                                <label for="WBS Element">WBS Element:</label>
                            </div>
                            <div class="col-sm-4">
                                <input type="text" id="mdlCdrId" name="mdlCdrId "
                                    [(ngModel)]="successfulData.selected.Id" style="display:none;" />
                                <input class="form-control" type="text" id="WBSElement" name="WBSElement"
                                    [(ngModel)]="successfulData.selected.wbs" />
                            </div>
                        </div>

                        <div class="form-group row" id="divApprover" [hidden]="!showApprover">
                            <div class="col-sm-3 col-md-offset-1" style="padding-top: 1%; margin-top: -20px;">
                                <span class="tooltip" style=" position: relative;">
                                    <img alt="" src="assets/img/info10.png" class="img-circle"
                                        style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 79%;">
                                    <span class="tooltiptext" style="margin-bottom: -16px;">Enter appropiate approver
                                        for the User.</span>
                                </span>
                                <label for="Approver">Approver:</label>
                            </div>
                            <div class="col-sm-4">
                                <input class="form-control" type="text" id="Approver" name="Approver"
                                    [(ngModel)]="successfulData.selected.approverEid" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-3 col-md-offset-1" style="padding-top: 1%; margin-top: -15px;">
                                <span class="tooltip" style=" position: relative;">
                                    <img alt="" src="assets/img/info10.png" class="img-circle"
                                        style="width: 12%; height: 10%; margin-bottom: -30%; margin-left: 79%;">
                                    <span class="tooltiptext" style="margin-bottom: -16px;">Reason why the call is
                                        marked as selected call type.</span>
                                </span>
                                <label for="Remarks">Remarks:</label>
                            </div>
                            <div class="col-sm-4">
                                <textarea class="form-control" id="Remarks" name="Remarks" [(ngModel)]="successfulData.selected.remarks"
                                    style="width:162px;" maxlength="1000"></textarea>
                            </div>
                        </div>
                        <div align="center">
                            <button type="submit" id="btnsave" class="btn btn-default btn-group-sm Button1"
                                (click)="MarkCallsAdd(successfulData.selected)"><span class=""
                                    aria-hidden="true"></span>Save</button>&nbsp;
                            <button type="submit" id="btnClose" class="btn btn-default btn-group-sm Button1"
                                (click)="closeModal()"><span class="fa fa-close"
                                    aria-hidden="true"></span>Cancel</button>
                        </div>
                    </div>
                    <!-- </ng-template> -->
                </div>
            </div>

            <div id="AlertForAccess" [ngStyle]="{'display':AlertForAccess}">
                <div class="row" style="padding-top:-20%">
                    <div class="col-sm-12" style="margin-left:5%;">
                        <h4 style="color:red;">
                            Access Not Available.Please refer User Guidelines section for any access or tool issue.
                        </h4>
                    </div>
                </div>
            </div>

            <div style="display:none" id="showMsg" [ngStyle]="{'display':showMsg}">
                <label
                    style="color: rgb(185, 180, 216); font-weight: bold; font-size: 15px;margin-left:5%; ">{{ErrorMessage}}</label>
            </div>

        </div>
    </div>
</form>